"use client";

import { c as _c } from "react/compiler-runtime";
import { classNames, Flex, TimeSeriesChartEmptyState } from "@opensea/ui-kit";
export function SalesChartEmptyState(t0) {
  const $ = _c(13);
  let className;
  let rest;
  if ($[0] !== t0) {
    ({
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = classNames("h-[400px]", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = rest.overrides?.Skeleton;
  let t3;
  if ($[5] !== t2) {
    t3 = {
      ...t2
    };
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== rest.overrides || $[8] !== t3) {
    t4 = <TimeSeriesChartEmptyState className="size-full" overrides={{
      ...rest.overrides,
      Skeleton: t3
    }} />;
    $[7] = rest.overrides;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t4) {
    t5 = <Flex className={t1}>{t4}</Flex>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}